export const version = '0.0.2';
export const currentQzCertificateVersion = "v2025.08.11";
